import { Rate, Slider } from 'antd'
import React, { useState } from 'react'
import { ReactComponent as Star } from "../../assets/img/icons/star-1.svg";
import { ReactComponent as Line } from "../../assets/img/icons/Line 32.svg";

const RateSlider = ({defaultvalue,setDefaultValue}) => {
   const customIcons = {
       1: <Star fill="#e6e8ea"  />,
       2: <Star  fill="#e6e8ea" />,
       3: <Star fill="#e6e8ea"   />,
       4: <Star fill="#e6e8ea"  />,
       5: <Star fill="#e6e8ea"   />
     };

    const onChange = (newValue) => {
        setDefaultValue(newValue);
      };
  return (
    <div className='RateSlider'>

        <Rate
          defaultvalue={defaultvalue}
          onChange={(e)=>onChange(e)}
          value={defaultvalue}
          allowHalf={true}
          
        // character={({ index }) => customIcons[index + 1]}
        />
      
        <Slider  min={0} max={5} reverse step={0.5} draggableTrack={true}  defaultValue={defaultvalue}  value={defaultvalue} onChange={(e)=>onChange(e)} />
    </div>
  )
}

export default RateSlider